import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ColorField from './ColorField';
import FontSizeControl from './FontSizeControl';

const FieldsRow = ({ fields, style, handleChange }) => {
  const theme = useTheme();

  if (fields.includes('fontColor') && fields.includes('fontSize')) {
    // Font color + Font size
    return (
      <Box sx={{ display: 'flex', gap: '16px', marginBottom: '12px' }}>
        <Box sx={{ flex: 1 }}>
          <ColorField label="Font Color" value={style.fontColor} onChange={value => handleChange('fontColor', value)} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontSize: theme.typography.customFontSize[1],
              color: theme.palette.primary.main,
              fontWeight: theme.typography.customFontWeight[1],
              marginBottom: '6px',
            }}
          >
            Font Size
          </Typography>
          <FontSizeControl value={style.fontSize} onChange={value => handleChange('fontSize', value)} />
        </Box>
      </Box>
    );
  } else if (fields.includes('fontColor') && fields.includes('buttonColor')) {
    // Font color + Button color
    return (
      <Box sx={{ display: 'flex', gap: '16px', marginBottom: '12px' }}>
        <Box sx={{ flex: 1 }}>
          <ColorField label="Font Color" value={style.fontColor} onChange={value => handleChange('fontColor', value)} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <ColorField label="Button Color" value={style.buttonColor} onChange={value => handleChange('buttonColor', value)} />
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};

export default FieldsRow;
